<template>
  <div class="login-container">
    <el-row>
      <el-col :lg="7" :md="6" :sm="24" :xl="7" :xs="24">
        <div style="color: transparent"></div>
      </el-col>
      <el-col :lg="10" :md="12" :sm="24" :xl="10" :xs="24">
        <el-form
          ref="form"
          class="login-form"
          label-position="left"
          :model="form"
          :rules="rules"
        >
          <!-- <div class="title">下午好 !</div> -->
          <div class="title-tips">
            {{ translateTitle('欢迎登录') }}{{ title }}
          </div>
          <el-form-item prop="appCode" style="margin-top: 40px" class="el-form-item">
            <el-input
              v-model.trim="form.appCode"
              v-focus
              :placeholder="translateTitle('请输入企业代码')"
              tabindex="1"
              type="text"
            >
              <template #prefix><vab-icon icon="building-line" /></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="customId">
            <el-input
              v-model.trim="form.customId"
              :placeholder="translateTitle('请输入帐号')"
              tabindex="2"
              type="text"
            >
              <template #prefix><vab-icon icon="user-line" /></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              :key="passwordType"
              ref="password"
              v-model.trim="form.password"
              :placeholder="translateTitle('请输入密码')"
              tabindex="3"
              :type="passwordType"
              @keyup.enter="handleLogin"
            >
              <template #prefix>
                <vab-icon icon="lock-line" />
              </template>
              <template v-if="passwordType === 'password'" #suffix>
                <vab-icon
                  class="show-password"
                  icon="eye-off-line"
                  @click="handlePassword"
                />
              </template>
              <template v-else #suffix>
                <vab-icon
                  class="show-password"
                  icon="eye-line"
                  @click="handlePassword"
                />
              </template>
            </el-input>
          </el-form-item>
          <el-button
            class="login-btn"
            :loading="loading"
            type="primary"
            @click="handleLogin"
          >
            {{ translateTitle('登录') }}
          </el-button>
          <router-link to="/register">
            <!-- <div style="margin-top: 20px">{{ translateTitle('注册') }}</div> -->
          </router-link>
        </el-form>
        <p class="footer">©2014-2021 上海昀活网络科技有限公司 &nbsp;&nbsp;&nbsp;&nbsp;沪ICP备18001015号-6 &nbsp;&nbsp;&nbsp;&nbsp;客服电话：021-6786 6532</p>
      </el-col>
      <el-col :lg="1" :md="1" :sm="24" :xl="1" :xs="24">
        <div style="color: transparent"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { translateTitle } from '@/utils/i18n'
  import { isPassword } from '@/utils/validate'
  import { getToken } from '@/api/user'
  import { findAppWidgetList } from '@/api/widget'
  import { initNotification } from '@/utils/notification'
  import storejs from 'store'

  export default {
    name: 'Login',
    directives: {
      focus: {
        inserted(el) {
          el.querySelector('input').focus()
        },
      },
    },
    beforeRouteLeave(to, from, next) {
      clearInterval(this.timer)
      next()
    },
    data() {
      const validateAppCode = (rule, value, callback) => {
        if ('' === value)
          callback(new Error(this.translateTitle('企业代码不能为空')))
        else callback()
      }
      const validateCustomId = (rule, value, callback) => {
        if ('' === value)
          callback(new Error(this.translateTitle('帐号不能为空')))
        else callback()
      }
      const validatePassword = (rule, value, callback) => {
        if (!isPassword(value))
          callback(new Error(this.translateTitle('密码不能少于6位')))
        else callback()
      }
      return {
        nodeEnv: process.env.NODE_ENV,
        form: {
          appId: 'appId',
          token: 'Toak',
          appCode: '',
          customId: '',
          password: '',
          typehood: 2,
        },
        rules: {
          appCode: [
            {
              required: true,
              trigger: 'blur',
              validator: validateAppCode,
            },
          ],
          customId: [
            {
              required: true,
              trigger: 'blur',
              validator: validateCustomId,
            },
          ],
          password: [
            {
              required: true,
              trigger: 'blur',
              validator: validatePassword,
            },
          ],
        },
        loading: false,
        passwordType: 'password',
        redirect: undefined,
        timer: 0,
      }
    },
    computed: {
      ...mapGetters({
        title: 'settings/title',
      }),
    },
    watch: {
      $route: {
        handler(route) {
          this.redirect = (route.query && route.query.redirect) || '/widget'
        },
        immediate: true,
      },
    },
    async mounted() {
      const token = await getToken()
      storejs.set('token', token)
      initNotification()
    },
    methods: {
      ...mapActions({
        login: 'user/login',
      }),
      translateTitle,
      handlePassword() {
        this.passwordType === 'password'
          ? (this.passwordType = '')
          : (this.passwordType = 'password')
        this.$nextTick(() => {
          this.$refs.password.focus()
        })
      },
      handleRoute() {
        return this.redirect === '/404' || this.redirect === '/403'
          ? '/logs/index'
          : this.redirect
      },
      handleLogin() {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              this.loading = true
              await this.login(this.form)
              const ret = await findAppWidgetList({ mode: 1, page: 1, size: 100, scope: 1 })
              storejs.set(`${storejs.get('appId')}-widgets`, ret && ret.list || [])
              await this.$router.push(this.handleRoute())
            } finally {
              this.loading = false
            }
          } else {
            return false
          }
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .login-container {
    height: 100vh;
    background-image: url('~@/assets/login_images/background.png');
    background-attachment: fixed;
    background-position-y: bottom;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #fff;
  }

  .el-form-item {
    margin-bottom: 2rem!important;
  }

  .login-form {
    position: relative;
    max-width: 400px;
    padding: 4.5vh;
    margin: 0 auto;
    margin-top: calc((100vh - 575px) / 2);
    overflow: hidden;
    // background: url('~@/assets/login_images/login_form.png');
    box-shadow: 0 .1rem 1rem .25rem rgba(0, 0, 0, .05);
    border-radius: .475rem;
    background: #fff;
    background-size: 100% 100%;


    .title {
      font-size: 42px;
      font-weight: 500;
      color: $base-color-white;
    }

    .title-tips {
      font-size: 24px;
      font-weight: 400;
      color: $base-color-black;
      text-align: center;
    }

    .login-btn {
      display: inherit;
      width: 100%;
      height: 48px;
      margin-top: 38px;
      border: 0;
      font-size: 15px;

      &:hover {
        opacity: 0.9;
      }

      .forget-passwordword {
        width: 100%;
        margin-top: 40px;
        text-align: left;

        .forget-password {
          width: 129px;
          height: 19px;
          font-size: 20px;
          font-weight: 400;
          color: rgba(92, 102, 240, 1);
        }
      }
    }

    .tips {
      margin-bottom: 10px;
      font-size: $base-font-size-default;
      color: $base-color-white;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .title-container {
      position: relative;

      .title {
        margin: 0 auto 40px auto;
        font-size: 34px;
        font-weight: bold;
        color: $base-color-blue;
        text-align: center;
      }
    }

    i {
      position: absolute;
      top: 8px;
      left: 5px;
      z-index: $base-z-index;
      font-size: 16px;
      color: #d7dee3;
      cursor: pointer;
      user-select: none;
    }

    .show-password {
      position: absolute;
      right: 25px;
      left: -35px;
      font-size: 16px;
      color: #d7dee3;
      cursor: pointer;
      user-select: none;
    }

    ::v-deep {
      .el-form-item {
        padding-right: 0;
        margin: 20px 0;
        color: #454545;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 2px;

        &__content {
          min-height: $base-input-height;
          line-height: $base-input-height;
        }

        &__error {
          position: absolute;
          top: 100%;
          left: 18px;
          font-size: $base-font-size-small;
          line-height: 18px;
          color: $base-color-red;
        }
      }

      .el-input {
        box-sizing: border-box;

        input {
          height: 48px;
          padding-left: 35px;
          font-size: $base-font-size-default;
          line-height: 58px;
          background: #f6f4fc;
          border: 0;
        }
      }
    }
  }
  .footer {
     position: fixed;
     bottom: 20px;
     left: 0;
     right: 0;
     width: 100%;
     text-align: center;
     color: #cccccc;
     padding: 0 20px;
     font-weight: normal;
  }
</style>
